package dev.lingvo.shared.screenshots.frames

import dev.lingvo.shared.DeviceClass
import dev.lingvo.shared.screenshots.doc.FrameKind
import dev.lingvo.shared.screenshots.geom.Rect
import dev.lingvo.shared.screenshots.render.ImageHandle
import dev.lingvo.shared.screenshots.render.Surface

/** Shares one vector geometry implementation between renderer, picker and editor. */
object VectorFrames : DeviceFrames {
    /** Fits the hardware footprint while keeping the capture aspect exact. */
    override fun layout(kind: FrameKind, box: Rect, screenAspect: Double, screenRadius: Double?): FrameLayout =
        FrameSpecs.of(kind).layout(box, screenAspect, screenRadius)

    /** Keeps image clipping and finish decisions identical in previews and exports. */
    override fun paint(surface: Surface, kind: FrameKind, layout: FrameLayout, options: FramePaintOptions, screen: ImageHandle?) =
        paintFrame(surface, kind, layout, options, screen)

    /** Uses the first compatible silhouette as the initial picker selection. */
    override fun defaultFor(device: DeviceClass): FrameKind = offeredFrames(device).first()

    /** Explicit exhaustive mapping prevents new display classes inheriting an unrelated silhouette. */
    override fun offeredFor(device: DeviceClass): List<FrameKind> = offeredFrames(device)
}
